export default __webpack_public_path__ + "static/media/accordion_on.f6407bf2.svg";